// extracted by mini-css-extract-plugin
export default {"root":"Sxxmni","picture":"W7SUd2","text":"vuYpTR"};